import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "mediaQuery"];
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import MediaQuery from './media-query';

/**
 * @type {React.FC<PropsWithChildren<{
 *  mediaQuery?: string;
 *  direction?: string;
 *  children?: Element;
 * }>>}
 */
var DesktopOnly = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$mediaQuery = _ref.mediaQuery,
    mediaQuery = _ref$mediaQuery === void 0 ? 'md' : _ref$mediaQuery,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return __jsx(MediaQuery, _extends({
    ref: ref,
    mediaQuery: mediaQuery
  }, otherProps, {
    direction: "up"
  }), children);
});
DesktopOnly.snapshot = false;
export default DesktopOnly;